<div class="mb-2">
  <hr class="recordDocumentType"/>
  <div class="mt-1 mb-1 resultHeader">
    <div class="iconStyling">
        <img src="../../../../assets/images/OAFDOrange.png"
          alt="{{ 'assessmentIcon' | translate | async }}" 
          attr.aria-label="{{ 'assessmentIcon' | translate | async }}" aria-hidden="true">
        <span class="ml-2">
            <a (click)="openInSameTab()" (dblclick)="openInNewTab()">
              {{ 'assessment.file.record' | translate | async }}: {{ fileId }}
            </a>
        </span>
    </div>
    <div class="iconStyling recordIcon">
      <img src="../../../../assets/images/record-icon-yellow.png" 
        alt="{{ 'recordIcon' | translate | async }}" 
        attr.aria-label="{{ 'recordIcon' | translate | async }}" aria-hidden="true">
    </div>
  </div>

  <div class="resultsCardContainer">
    <div *ngIf="primaryTownship" class="flex mb-0">
        <p class="resultsCardSubtitle font-weight--bold ">{{ 'primary.township.area' | translate | async }}</p>
        <p class="recordValue" innerHTML="{{ primaryTownship | highlight : this.searchTerms }}">
          {{ primaryTownship | highlight : this.searchTerms }}
        </p>
    </div>
    <div *ngIf="year" class="flex mb-0">
        <p class="resultsCardSubtitle font-weight--bold ">{{ 'year.work.performed' | translate | async }}</p>
        <p class="recordValue">{{ year }}</p>
    </div>
    <div *ngIf="performedFor.length > 0" class="flex mb-0">
        <p class="resultsCardSubtitle font-weight--bold ">{{ 'performed.for' | translate | async }}</p>
        <p class="recordValue" innerHTML="{{ performedFor | commaSeparatedPipe:'name' | notApplicablePipe | async | highlight : this.searchTerms }}">
          {{ performedFor | commaSeparatedPipe:'name' | notApplicablePipe | async | highlight : this.searchTerms }}
        </p>
    </div>
    <div *ngIf="workTypes.length > 0" class="flex mb-0">
        <p class="resultsCardSubtitle font-weight--bold ">{{ 'work.type' | translate | async }}</p>
        <p class="recordValue" innerHTML="{{ workTypes | commaSeparatedPipe:'description' | notApplicablePipe | async | highlight : this.searchTerms }}">
          {{ workTypes | commaSeparatedPipe:'description' | notApplicablePipe | async | highlight : this.searchTerms }}
        </p>
    </div>
  </div>
</div>